import {AnalyticsEventHandler} from "../../../infrastructure/handlers/analytics-event-handler";
import {AnalyticsService} from "../../../third-party-services/analytics/analytics-service";
import {H2hWidgetState} from "../models/h2h-widget.state";
import {H2hWidgetController} from "../h2h-widget.controller";
import {H2H} from "../h2h-widget.consts";
import {H2hWidgetAnalyticsDisplayEvent} from "../models/h2h-widget.analytics-display.event";

export class H2hWidgetAnalyticsDisplayHandler extends AnalyticsEventHandler {
  state: H2hWidgetState;
  controller: H2hWidgetController;
  type = H2H.ACTION_TYPES.displayHandler;

  static injectables = [AnalyticsService];

  async action() {
    const params = {
      gameId: this.state.gameId,
      status: this.state.statusGroup,
      sportTypeId: this.state.appState.context.sportType?.id
    }

    const clickEvent = new H2hWidgetAnalyticsDisplayEvent(params);

    await this.analyticsService.createEvent(clickEvent);
  }
}
